// <Standings> — the 房间战绩 overlay (#standings), opened anytime via the 🏆 button by the
// classic showStandings() window fn. PURE function of `app`: reads app.room.standings (the
// cumulative ranking of finished games in THIS room) and renders the .overlay/.sheet rows,
// exactly as the old imperative string did — Preact DIFFS instead of clobbering. Emits the
// SAME class names + data-action="close-standings" so document-level click delegation + the
// smoke grep contract stay green. See PREACT-MIGRATION.md.
import { html, OverlaySheet, Banner, rankBadge, signed, glyph, t } from '../shared.js';

export function Standings({ app }: { app: AppState }) {
  const rs: Standing[] = (app && app.room && app.room.standings) || [];
  const totalGames = rs.reduce((m: number, s: Standing) => Math.max(m, s.games || 0), 0);
  return html`<${OverlaySheet} close="close-standings">
      <${Banner} title=${t('standings.title')} sub=${t('standings.sub', { n: totalGames })} size="clamp(26px,8vw,42px)" />
      <div class="scoreboard">
        ${rs.length
          ? rs.map((s: Standing, i: number) => html`
            <div class="score-row" key=${s.id || s.name || i}>
              <div class="rank">${rankBadge(i)}</div>
              <div class="score-main"><b>${glyph(s)} ${s.name}</b><div class="breakdown">${t('standings.record', { wins: s.wins, games: s.games })}</div></div>
              <div class="score-right"><div class="score-val">${signed(s.score)}</div></div>
            </div>`)
          : html`<div class="muted" style="text-align:center;font-weight:800;padding:20px" dangerouslySetInnerHTML=${{ __html: t('standings.empty') }}></div>`}
      </div>
    </${OverlaySheet}>
  `;
}
